/**
 * Detect if the user is connected from the US (locale or timezone).
 * Used to show $ instead of € for pricing.
 */
export function isUSLocale() {
    if (typeof navigator === 'undefined') return false;
    const lang = navigator.language || navigator.userLanguage || '';
    if (lang.startsWith('en-US')) return true;
    try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
        return tz.startsWith('America/');
    } catch {
        return false;
    }
}

/**
 * Returns '$' for US users, '€' otherwise.
 */
export function getCurrencySymbol() {
    return isUSLocale() ? '$' : '€';
}
